export class BorrowedInfo {
    public id: string;
    public loanApplicationId: string;
    public noOfLoans: number;
    public sumOfEmis: number;
    public borrowedStatus: BorrowedStatus;
    public version: number;

    constructor(borrowedStatus: BorrowedStatus,
                loanApplicationId: string,
                noOfLoans?: number,
                sumOfEmis?: number) {
        this.borrowedStatus = borrowedStatus;
        this.loanApplicationId = loanApplicationId;
        this.noOfLoans = noOfLoans;
        this.sumOfEmis = sumOfEmis;
        this.id = null;
        this.version = null;
    }
}

export enum BorrowedStatus {
    BORROWED = "BORROWED",
    NOT_BORROWED = "NOT_BORROWED"
}
